import React, { useEffect, useState } from 'react'
import { message } from 'antd'
import { UserInfoHS, DWSendCodeHttp as sendCodeHttp } from 'src/commons/store/UserStore'
import { signatureEncode } from 'src/commons/utils'
import { GetChannel } from 'src/commons/utils/index'

/**
 * @description 发送验证码功能
 * @param initText 初始化按钮文案
 * @param initTime 初始化间隔时间
 * @return {sendCode} 发送验证码的事件
 * @return {text} 发送验证码的按钮文案
 * @return {isLoading} 当前是否在冷却中
 */
const useSendCode = (initText?: string, initTime?: number) => {
  const [text, setText] = useState<string>(initText || '发送验证码')

  // const [count, setCount] = useState<number>(initTime || 60)

  const [isLoading, setIsLoading] = useState<boolean>(true)

  const [timer, setTimer] = useState<number | null>(null)

  const CountDownSendPhoneCode = (count: number) => {
    if (count === 0) {
      timer && clearTimeout(timer)
      setTimer(null)
      setIsLoading(true)
      setText(initText || '获取验证码')
    } else {
      setIsLoading(false)
      setText(`${count}秒后重发`)
      setTimer(window.setTimeout(() => {
        CountDownSendPhoneCode(count - 1)
      }, 1000))
    }
  }

  useEffect(() => {
    return () => {
      timer && clearTimeout(timer)
      setTimer(null)
    }
  }, [])

  const sendCode = async ({mobile, action, NVCVal, captchaType}: UseSendCodePayload) => {
    if (!isLoading) {
      return 
    }
    if (!mobile || mobile.length !== 11) {
      return message.warn('请填写正确的手机号')
    }
    const userInfo = UserInfoHS.SuccessResult
    const phoneNo = mobile || (userInfo ? userInfo.mobile : '')
    try {
      const time = new Date().getTime()
      await sendCodeHttp.Execute({ 
        mobile: phoneNo, 
        action, 
        a: NVCVal || '', 
        captcha_type: captchaType || 3,
        channel: GetChannel()
      }, {
        headers: {
          timestamp: String(time),
          signature: signatureEncode(phoneNo + '.' + time),
        },
      })
      message.success('短信发送成功')
      CountDownSendPhoneCode(initTime || 60)
    } catch (error) {
      message.warn(error.message)
      console.log(error)
    }
  }

  return {sendCode, text, isLoading}
}

export default useSendCode